import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@/App.css';
import App from '@/App.js';
import {CssBaseline, createTheme} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

const theme = createTheme({
    palette: {
        primary: {
            main: '#631d79',
            50: '#FAF5FF',
        },
        secondary: {
            main: '#9333EA',
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff',
        },
    },
    typography: {
        h1: {
            color: '#631d79',
        },
        h2: {
            color: '#631d79',
        },
        h3: {
            color: '#631d79',
        },
    },
});

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element missing');
}

const root = createRoot(container);
root.render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    </StrictMode>,
);
